import { formatDate } from "./formatDate.js";
const formatDateRange = (startDate, endDate, dayFormat = "Do", monthFormat = "MMM", yearFormat = "YYYY") => {
  const dateFormat = `${dayFormat} ${monthFormat} ${yearFormat}`;
  if (startDate == null ? void 0 : startDate.isSame(endDate, "day")) {
    return formatDate(startDate, dateFormat);
  }
  if (startDate == null ? void 0 : startDate.isSame(endDate, "month")) {
    return `${startDate.format(dayFormat)} - ${formatDate(endDate, dateFormat)}`;
  }
  if (startDate == null ? void 0 : startDate.isSame(endDate, "year")) {
    return `${startDate.format(`${dayFormat} ${monthFormat}`)} - ${formatDate(endDate, dateFormat)}`;
  }
  return `${formatDate(startDate, dateFormat)} - ${formatDate(endDate, dateFormat)}`;
};
export {
  formatDateRange
};
//# sourceMappingURL=formatDateRange.js.map
